import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const WarimashiHasuShoriKbn = props => {
  return <Dropdown.Static kubunKey='warimashi_hasu_shori_kbn' {...props} />
}
